import React, {useContext} from "react";
import UserContext from "../../contexts/UserContext";
import Header from "../Navigation/Header";
import TableauReports from "../Tableau/TableauReports.jsx";
import { useLocation, useNavigate } from 'react-router-dom';
import css from "../../css/common.module.css";

function HomePage({ signedIn }) {
	const userCtx = useContext(UserContext);
	const location = useLocation();
	const navigate = useNavigate();

	return (
		<>
			<Header />
			<div id="page">
				<div className="page-inner">
					{location.state && location.state.errorMessage && (
					<div className={"container-fluid viewh-85 "}>
						<div className="row">
							<div className="col-md-4 col-sm-4 mt-8"></div>
							<div className="col-md-4 col-sm-4 mt-2">
								<div id="inerrorMessage" className={css.errorblock}>
									{location.state.errorMessage}
								</div>
							</div>
							<div className="col-md-4 col-sm-4 mt-8"></div>
						</div>
					</div>
					)}
					<div id="main">
						{signedIn &&
							(<div style={{ backgroundColor: "#1d7d16", color: "white" }}>
								<p>Signed in successfully.</p>
							</div>
							)}
						{(userCtx && (userCtx.role === "admin" || userCtx.role === "read_access")) ?
							<TableauReports /> :
							(userCtx && userCtx.role === "public_read_access") ?
								<div style={{display: 'block', margin: '40px auto', textAlign: 'center'}}>
									<img style={{top: "0%", left: "0%", maxHeight: "800px", maxWidth: "1200px"}} src="images/PublicUserLandingPage.png" alt=""/>
								</div>
								: <div></div>
						}

					</div>
				</div>
			</div>
		</>
	);
}
export default HomePage;
